import CryptoJS from 'crypto-js';
import { getConfigVar } from 'config/config';

export const encrypt = (text: string, key: string = getConfigVar('REACT_APP_ENCRYPT_KEY')): string => {
  const encrypted = CryptoJS.AES.encrypt(text, key).toString();

  return encrypted;
};
